import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "preact/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState, } from 'preact/compat';
import { useController, useFormContext, } from 'react-hook-form';
import { clsx } from 'clsx';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormError from '@enquiryForm/components/FormError';
function SortCodeInput(props) {
    const { inputAttrs, labelAttrs, forceError } = props;
    const refs = useRef(new Array(3).fill(null));
    const { name, className: forwardedInputClasses } = inputAttrs;
    const [isModified, setIsModified] = useState(false);
    const [sortCodeInputs, setSortCodeInputs] = useState(Array(3).fill(0).map((_, i) => ({
        inputAttrs: {
            ...inputAttrs,
            name: `${inputAttrs.name}-${i}`,
            id: `${inputAttrs.id}-${i}`,
        },
        labelAttrs: {
            ...labelAttrs,
            htmlFor: `${inputAttrs.id}-${i}`,
            text: `${labelAttrs.text} Column ${i + 1}`,
            hidden: true,
        },
        value: '',
    })));
    const { control, setValue, formState: { isSubmitted } } = useFormContext();
    const { field: { value }, fieldState: { isDirty, invalid, isTouched, error, }, } = useController({ name, control });
    const className = clsx('form__control', forwardedInputClasses, { invalid: invalid && (isTouched || isSubmitted || forceError) });
    const formattedValue = useMemo(() => sortCodeInputs.reduce((carry, input) => carry + input.value, '') ?? '', [sortCodeInputs]);
    const handleValueUpdate = useCallback(() => {
        if (isModified) {
            setValue(name, formattedValue, {
                shouldTouch: true,
                shouldValidate: true,
            });
        }
    }, [isModified, formattedValue]);
    useEffect(handleValueUpdate, [formattedValue]);
    const handleInputChange = (ev, idx) => {
        const updatedInputs = [...sortCodeInputs];
        const { value: formValue } = ev.currentTarget;
        console.log('Form Value Length: ', formValue.length);
        console.log('Refs: ', refs.current.length);
        console.log('idx: ', idx);
        setIsModified(true);
        let targetIndex = idx + 1;
        const updatedValue = formValue;
        // if this is the last, then do nothing.
        // if (formValue.length >= 2 && (idx + 1) === refs.current.length) {
        //   return;
        // }
        if (formValue.length >= 2 && (idx + 1) < refs.current.length) {
            console.log('Should switch focus');
            targetIndex = idx + 1;
            refs.current[targetIndex].focus();
        }
        updatedInputs[idx] = {
            ...updatedInputs[idx],
            value: formValue.slice(0, 2),
        };
        setSortCodeInputs(updatedInputs);
    };
    // const handleInputChange = useCallback((ev: ChangeEvent) => {
    //   setValue(
    //     name,
    //     (ev.currentTarget as HTMLInputElement).value as PathValue<T, Path<T>>,
    //     { shouldTouch: true, shouldValidate: true },
    //   );
    // }, [name, setValue]);
    return (_jsxs(FormGroup, { className: error ? 'form__group--error' : '', children: [_jsxs("span", { className: "form__label", children: [labelAttrs.text, labelAttrs.isFieldRequired && '*'] }), _jsx("div", { className: "form__sort-code", children: sortCodeInputs.map(({ inputAttrs: sortCodeInputAttrs, labelAttrs: sortCodeLabelAttrs, value: sortCodeValue }, idx) => (_jsxs(_Fragment, { children: [_jsx(FormLabel, { ...sortCodeLabelAttrs }), _jsx("input", { ...sortCodeInputAttrs, onKeyDown: (ev) => {
                                const { value: formValue } = ev.currentTarget;
                                // focus previous input as required.
                                if (ev.key === 'Backspace') {
                                    // previous ref
                                    if (formValue.length - 1 < 0 && idx - 1 >= 0) {
                                        ev.preventDefault();
                                        refs.current[idx - 1].focus();
                                    }
                                }
                            }, onPaste: (ev) => {
                                ev.preventDefault();
                                // @ts-ignore
                                let paste = (ev.clipboardData || window.clipboardData).getData('text/plain');
                                console.log('Pasting: ', paste.length);
                                if (paste.length > 0) {
                                    // if the given input is not a number then just ignore it..
                                    if (Number.isNaN(parseInt(paste, 10))) {
                                        return;
                                    }
                                    // stripping any potential characters here and fixing to 6 characters.
                                    paste = parseInt(paste, 10).toString();
                                    paste = paste.length > 6 ? paste.slice(0, 6) : paste;
                                    const chunks = [];
                                    for (let i = 0; i < paste.length; i += 2) {
                                        const substringIdx = i + 2 >= paste.length ? paste.length : i + 2;
                                        chunks.push(paste.substring(i, substringIdx));
                                    }
                                    const newSortCodeInputs = [...sortCodeInputs];
                                    newSortCodeInputs.forEach((_, inputIdx) => {
                                        newSortCodeInputs[inputIdx] = {
                                            ...newSortCodeInputs[inputIdx],
                                            value: chunks[inputIdx] ? chunks[inputIdx] : '',
                                        };
                                    });
                                    setIsModified(true);
                                    refs.current[chunks.length - 1].focus();
                                    setSortCodeInputs(newSortCodeInputs);
                                }
                            }, onChange: (ev) => handleInputChange(ev, idx), value: sortCodeValue, className: className, ref: (el) => {
                                // this should never be null but if it is then this will likely cause issues
                                if (el) {
                                    refs.current[idx] = el;
                                }
                            } })] }))) }), (error && (isTouched || isSubmitted || forceError)) && (_jsx(FormError, { children: error?.message }))] }));
}
SortCodeInput.defaultProps = {
    forceError: false,
};
export default SortCodeInput;
